import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './users_style.css';
import Swal from "sweetalert2";
import { FaExclamationCircle } from 'react-icons/fa';

const UpdateUserComponent = ({ userId, onClose, onUpdate }) => {
    // Estados de datos y vistas
    const [userData, setUserData] = useState(null);
    const [currentView, setCurrentView] = useState('perfil');
    const [errorMessage, setErrorMessage] = useState('');
    const [search, setSearch] = useState(''); // Estado para el buscador

    // Estados para selects y permisos
    const [userProfiles, setUserProfiles] = useState([]);
    const [areas, setAreas] = useState([]);
    const [roles, setRoles] = useState([]);
    const [permissions, setPermissions] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);

    // Lógica del buscador de permisos
    const filteredPermissions = permissions.filter(permission =>
        permission.name.toLowerCase().includes(search.toLowerCase())
    );

    // Obtención de datos iniciales del usuario
    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/users/${userId}`, {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                    },
                });
                setUserData(response.data.data[0]);
            } catch (error) {
                console.error(error);
            }
        };
        fetchUserData();
    }, [userId]);

    // Obtención de catálogos (Perfiles, Áreas, Roles)
    useEffect(() => {
        const fetchData = async () => {
            try {
                const headers = { Authorization: `Bearer ${sessionStorage.getItem("token")}` };
                const [resProfiles, resAreas, resRoles] = await Promise.all([
                    axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/user_profiles`, { headers }),
                    axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/users/getAreas`, { headers }),
                    axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/users/getRoles`, { headers })
                ]);
                setUserProfiles(resProfiles.data.data);
                setAreas(resAreas.data.data);
                setRoles(resRoles.data.data);
            } catch (error) {
                console.error("Error cargando catálogos", error);
            }
        };
        fetchData();
    }, []);

    // Obtención de permisos específicos del usuario
    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/permissions/${userId}`, {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                    },
                });
                if (Array.isArray(res.data.data)) {
                    setPermissions(res.data.data);
                }
            } catch (error) {
                console.error(error);
                Swal.fire("Error", "No se pudieron obtener los permisos", "error");
            }
        };
        fetchPermissions();
    }, [userId]);

    const handleUpdate = async () => {
        setIsUpdating(true); 
        try {
            const updatedData = {
                first_name: document.getElementById("first_name").value,
                last_name: document.getElementById("last_name").value,
                email: document.getElementById("email").value,
                role_id: document.getElementById("role_id").value,
                area_id: document.getElementById("area_id").value,
                user_profile: document.getElementById("user_type").value,
            };
            const password = document.getElementById("password").value;
            const confirm_password = document.getElementById("confirm_password").value;

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!updatedData.first_name || !updatedData.last_name || !updatedData.email) {
                setErrorMessage("Los campos con * son obligatorios.");
                setIsUpdating(false);
                return;
            }

            if (!emailRegex.test(updatedData.email)) {
                setErrorMessage("Por favor, ingrese un correo electrónico válido");
                setIsUpdating(false);
                return;
            }

            if (password && password !== confirm_password) {
                setErrorMessage("Las contraseñas no coinciden.");
                setIsUpdating(false);
                return;
            }

            setErrorMessage('');
            if (password) updatedData.password = password;

            const res = await axios.put(`${process.env.REACT_APP_URL_BACKEND}/api/v1/users/update/${userId}`, updatedData, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
            });

            if (res.status === 200) {
                Swal.fire("¡Actualizado!", "Usuario actualizado exitosamente.", "success");
                onUpdate();
                onClose();
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Hubo un error al actualizar", "error");
        } finally {
            setIsUpdating(false);
        }
    };

    const handleRadioChange = async (id_permiso, permission) => {
        try {
            setPermissions((prev) =>
                prev.map((p) => (p.id === id_permiso ? { ...p, access: permission } : p))
            );

            await axios.post(
                `${process.env.REACT_APP_URL_BACKEND}/api/v1/permissions/update`,
                { id_user: userId, id_permiso, permission },
                {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
                }
            );
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "No se pudo actualizar el permiso", "error");
        }
    };

    if (!userData || areas.length === 0 || roles.length === 0) return <p>Cargando...</p>;

    return (
        <div>
            <div className="btn-group mb-3" role="group">
                <button type="button" className={`btnn me-2 ${currentView === 'perfil' ? 'active' : ''}`} onClick={() => setCurrentView('perfil')}>Perfil</button>
                <button type="button" className={`btnn ${currentView === 'permisos' ? 'active' : ''}`} onClick={() => setCurrentView('permisos')}>Permisos</button>
            </div>

            {currentView === 'perfil' && (
                <div>
                    <form className="row mb-3 text-start">
                        <div className="col-md-6 mb-3">
                            <label>Nombre *</label>
                            <input type="text" className="form-control" id="first_name" defaultValue={userData.first_name} />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label>Apellido *</label>
                            <input type="text" className="form-control" id="last_name" defaultValue={userData.last_name} />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label>Correo Electrónico *</label>
                            <input type="email" className="form-control" id="email" defaultValue={userData.email} />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label>Rol de Usuario *</label>
                            <select className="form-select" id="role_id" defaultValue={userData.role_id}>
                                {roles.map((rol) => <option key={rol.id} value={rol.id}>{rol.name}</option>)}
                            </select>
                        </div>
                        <div className="col-md-6 mb-3">
                            <label>Área *</label>
                            <select className="form-select" id="area_id" defaultValue={userData.area_id}>
                                <option value="">Elija una opción</option>
                                {areas.map((area) => <option key={area.id} value={area.id}>{area.name}</option>)}
                            </select>
                        </div>
                        <div className="col-md-6 mb-3">
                            <label>Perfil de usuario *</label>
                            <select className="form-select" id="user_type" defaultValue={userData.user_profile}>
                                <option value="">Elija una opción</option>
                                {userProfiles.map((up) => <option key={up.id} value={up.id}>{up.name}</option>)}
                            </select>
                        </div>
                        <div className="col-md-6 mb-3">
                            <label>Contraseña</label>
                            <input type="password" className="form-control" id="password" />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label>Confirmar Contraseña</label>
                            <input type="password" className="form-control" id="confirm_password" />
                        </div>
                        {errorMessage && (
                            <div className="col-12 error-message mt-2">
                                <FaExclamationCircle style={{ color: '#721c24', marginRight: '5px' }} />
                                {errorMessage}
                            </div>
                        )}
                    </form>
                    <div className="mt-3">
                        <button className="btn btn-success me-2" onClick={handleUpdate} disabled={isUpdating}>Actualizar</button>
                        <button className="btn btn-danger" onClick={onClose}>Cancelar</button>
                    </div>
                </div>
            )}

            {currentView === 'permisos' && (
                <div>
                    <div className="form-group mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Buscar módulo por nombre..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>
                    <div className='table-responsive create-profile'>
                        <table className="table table-hover table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>Módulo</th>
                                    <th>Sin Acceso</th>
                                    <th>Con Acceso</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredPermissions.map((permission) => (
                                    <tr key={permission.id}>
                                        <td className="text-start">{permission.name}</td>
                                        <td>
                                            <input
                                                type="radio"
                                                name={`perm-${permission.id}`}
                                                checked={!permission.access}
                                                onChange={() => handleRadioChange(permission.id, false)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="radio"
                                                name={`perm-${permission.id}`}
                                                checked={permission.access}
                                                onChange={() => handleRadioChange(permission.id, true)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                                {filteredPermissions.length === 0 && (
                                    <tr>
                                        <td colSpan="3">No se encontraron módulos.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UpdateUserComponent;